/* AUREA landing · React app (Babel JSX) */
/* Resolver de imágenes: soporta dos formatos de window.AUREA_IMG —
   (a) string con la ruta base de /assets/ ; (b) objeto { "nombre.jpg": "https://cdn.shopify..." } */
function AUREA_ASSET(name) {
  var m = window.AUREA_IMG;
  if (!m) return name;
  if (typeof m === 'string') return m + name;
  return m[name] || name;
}
/* ============================================================
   AUREA · Contenido + componentes compartidos
   ============================================================ */

const LAUNCH_DATE = new Date('2026-07-15T09:00:00-04:00'); // lanzamiento

/* ---- Logo ---- */
function Logo({
  variant = 'gold',
  height = 28,
  style = {}
}) {
  const cls = variant === 'white' ? 'aurea-logo aurea-logo--white' : 'aurea-logo';
  return /*#__PURE__*/React.createElement("img", {
    src: AUREA_ASSET("aurea-logo.png"),
    alt: "Aurea",
    className: cls,
    style: {
      height,
      ...style
    }
  });
}

/* ---- Asterisco de marca (glifo simple) ---- */
function Aster({
  className = ''
}) {
  return /*#__PURE__*/React.createElement("span", {
    className: 'aster ' + className,
    "aria-hidden": "true"
  }, "\u2733");
}

/* ---- Hook de aparición al hacer scroll ---- */
function useReveal() {
  React.useEffect(() => {
    const els = document.querySelectorAll('.reveal:not(.in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(e => e.classList.add('in'));
      return;
    }
    const io = new IntersectionObserver(ents => {
      ents.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -8% 0px'
    });
    els.forEach(e => io.observe(e));
    return () => io.disconnect();
  });
}

/* ---- Countdown ---- */
function useCountdown(target) {
  const [t, setT] = React.useState(() => Math.max(0, target - Date.now()));
  React.useEffect(() => {
    const id = setInterval(() => setT(Math.max(0, target - Date.now())), 1000);
    return () => clearInterval(id);
  }, [target]);
  const d = Math.floor(t / 86400000);
  const h = Math.floor(t % 86400000 / 3600000);
  const m = Math.floor(t % 3600000 / 60000);
  const s = Math.floor(t % 60000 / 1000);
  return {
    d,
    h,
    m,
    s,
    done: t <= 0
  };
}
function Countdown({
  tone = 'light'
}) {
  const c = useCountdown(LAUNCH_DATE.getTime());
  const cell = (v, label) => /*#__PURE__*/React.createElement("div", {
    className: "cd-cell"
  }, /*#__PURE__*/React.createElement("span", {
    className: "cd-num"
  }, String(v).padStart(2, '0')), /*#__PURE__*/React.createElement("span", {
    className: "cd-label"
  }, label));
  return /*#__PURE__*/React.createElement("div", {
    className: 'countdown countdown--' + tone
  }, cell(c.d, 'días'), /*#__PURE__*/React.createElement("span", {
    className: "cd-sep"
  }, ":"), cell(c.h, 'hrs'), /*#__PURE__*/React.createElement("span", {
    className: "cd-sep"
  }, ":"), cell(c.m, 'min'), /*#__PURE__*/React.createElement("span", {
    className: "cd-sep"
  }, ":"), cell(c.s, 'seg'));
}

/* ---- Klaviyo ---- */
const KLAVIYO_PUBLIC_KEY = 'UT6EAk';
const KLAVIYO_LIST_ID = 'VynHfn';

/* ---- Formulario lista de espera ---- */
function WaitlistForm({
  tone = 'light',
  compact = false,
  id = 'wl'
}) {
  const KEY = 'aurea_waitlist';
  const [email, setEmail] = React.useState('');
  const [done, setDone] = React.useState(false);
  const [err, setErr] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const submit = async e => {
    e.preventDefault();
    const value = email.trim();
    const ok = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value);
    if (!ok) {
      setErr('Ingresa un correo válido');
      return;
    }
    setErr('');
    setLoading(true);
    try {
      // Klaviyo — suscripción a lista (Client API, requiere Public API Key)
      await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: value
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: KLAVIYO_LIST_ID
                }
              }
            }
          }
        })
      });
    } catch (err) {
      // No bloqueamos la confirmación si la red falla
    }
    try {
      localStorage.setItem(KEY, value);
    } catch (e) {}
    setLoading(false);
    setEmail('');
    setDone(true);
    setTimeout(() => setDone(false), 3000);
  };
  if (done) {
    return /*#__PURE__*/React.createElement("div", {
      className: 'wl-done wl-done--' + tone
    }, /*#__PURE__*/React.createElement("span", {
      className: "wl-done-mark"
    }, "\u2733"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Est\xE1s en la Lista Dorada."), /*#__PURE__*/React.createElement("p", null, "Te escribiremos a tu correo con tu acceso anticipado y tu precio congelado. Revisa tu bandeja (y el spam, por si acaso).")));
  }
  return /*#__PURE__*/React.createElement("form", {
    className: 'wl wl--' + tone + (compact ? ' wl--compact' : ''),
    onSubmit: submit,
    noValidate: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "wl-row"
  }, /*#__PURE__*/React.createElement("input", {
    className: "field wl-input",
    type: "email",
    inputMode: "email",
    autoComplete: "email",
    placeholder: "tucorreo@ejemplo.cl",
    value: email,
    "aria-label": "Correo electr\xF3nico",
    onChange: e => {
      setEmail(e.target.value);
      if (err) setErr('');
    }
  }), /*#__PURE__*/React.createElement("button", {
    className: 'btn ' + (tone === 'onGold' ? 'btn-ink' : tone === 'dark' ? 'btn-gold' : 'btn-gold'),
    type: "submit",
    disabled: loading
  }, loading ? 'Enviando…' : 'Quiero acceso anticipado')), err ? /*#__PURE__*/React.createElement("span", {
    className: "wl-err"
  }, err) : null);
}

/* ============================================================
   DATOS
   ============================================================ */

const NAV = [{
  href: '#promesa',
  label: 'La promesa'
}, {
  href: '#beneficios',
  label: 'Beneficios'
}, {
  href: '#formula',
  label: 'Fórmula'
}, {
  href: '#regalo',
  label: 'El regalo'
}, {
  href: '#preguntas',
  label: 'Preguntas'
}];
const BENEFITS = [{
  k: '01',
  t: 'Menos hinchazón',
  d: 'Una mezcla de 14 cepas probióticas y fibra vegetal que acompaña a tu microbiota para que tu abdomen se sienta más liviano día a día.'
}, {
  k: '02',
  t: 'Digestión en calma',
  d: 'Hongos adaptógenos y greens pensados para apoyar una digestión más serena, sin esa pesadez después de comer.'
}, {
  k: '03',
  t: 'Mente clara',
  d: 'El eje intestino–cerebro es real. Cuando tu interior está en equilibrio, la cabeza también respira.'
}, {
  k: '04',
  t: 'Defensas y brillo',
  d: 'Wellmune® betaglucano y astaxantina, dos activos premium que apoyan tus defensas y tu vitalidad desde adentro.'
}];
const FORMULA = [{
  t: '14 cepas probióticas',
  d: 'Una comunidad viva que repuebla y equilibra tu microbiota intestinal.'
}, {
  t: 'Hongos adaptógenos',
  d: 'Apoyan la respuesta al estrés y la sensación de calma sostenida.'
}, {
  t: 'Astaxantina',
  d: 'Antioxidante de origen marino, asociado a vitalidad y belleza de la piel.'
}, {
  t: 'Wellmune® Betaglucano',
  d: 'Activo clínicamente estudiado para apoyar el sistema inmune.'
}, {
  t: 'Greens & polifenoles',
  d: 'Concentrado verde rico en compuestos vegetales protectores.'
}, {
  t: 'Fibra vegetal',
  d: 'Alimenta a tus probióticos y favorece el tránsito natural.'
}];
const FACTS = [{
  n: '14',
  l: 'cepas probióticas'
}, {
  n: '30',
  l: 'porciones de 7,79 g'
}, {
  n: 'Tropical',
  l: 'maracuyá & piña'
}, {
  n: '0',
  l: 'azúcar · solo stevia'
}];
const RITUAL = [{
  n: '01',
  t: 'Sirve',
  d: 'Agrega una porción (7,79 g) a 200–250 ml de agua fría en tu termo mezclador AUREA.'
}, {
  n: '02',
  t: 'Agita',
  d: 'Tapa y agita 10 segundos. Verás cómo se disuelve en un dorado suave de maracuyá y piña.'
}, {
  n: '03',
  t: 'Presencia',
  d: 'Bébelo en ayunas o cuando lo necesites. Un minuto para ti, todos los días.'
}];
const TESTIMONIALS = [{
  q: 'Por primera vez en años no termino el día con el botón del pantalón apretado. Es sutil, pero lo notas.',
  a: 'Catalina R.',
  m: 'Beta tester · Santiago'
}, {
  q: 'El sabor maracuyá–piña es lo que me hace tomarlo sin falta. No sabe a “remedio”, sabe a ritual.',
  a: 'Javiera M.',
  m: 'Beta tester · Viña del Mar'
}, {
  q: 'Lo que más me gustó fue sentir la panza más liviana y la cabeza más tranquila a media mañana.',
  a: 'Fernanda T.',
  m: 'Beta tester · Providencia'
}];
const FAQS = [{
  q: '¿Qué es AUREA Greens & Superfoods?',
  a: 'Es un batido diario de greens y superfoods formulado con una cepa de 14 probióticos, hongos adaptógenos, astaxantina, Wellmune® betaglucano, greens y polifenoles. Está pensado para acompañar tu bienestar digestivo y mental, con un sabor 90% maracuyá y 10% piña, endulzado solo con stevia.'
}, {
  q: '¿Qué gano si me sumo a la Lista Dorada?',
  a: 'Dos cosas: (1) acceso al checkout 24 horas antes que el público general y (2) un precio exclusivo de lanzamiento que queda congelado para ti por 24 meses. Te avisamos por correo apenas abramos.'
}, {
  q: '¿Cuándo es el lanzamiento?',
  a: 'Estamos afinando los últimos detalles. Quienes estén en la Lista Dorada serán los primeros en enterarse de la fecha y los primeros en poder comprar.'
}, {
  q: '¿Qué incluye el regalo de suscripción?',
  a: 'Al suscribirte recibes de regalo un termo mezclador AUREA en color blanco y un frasco de Vitamina D3+K2 (30 cápsulas) para complementar tu ritual de bienestar.'
}, {
  q: '¿Cómo se toma y a qué sabe?',
  a: 'Una porción de 7,79 g disuelta en agua fría, idealmente en tu termo mezclador. Sabe a maracuyá con un toque de piña, suave y refrescante. Sin azúcar: endulzado solo con stevia.'
}, {
  q: '¿Puedo cancelar la suscripción cuando quiera?',
  a: 'Sí. La suscripción es flexible: puedes pausarla o cancelarla cuando lo necesites desde tu cuenta. Tu precio de lanzamiento se mantiene mientras tu suscripción siga activa.'
}, {
  q: '¿AUREA reemplaza una alimentación equilibrada?',
  a: 'No. AUREA es un suplemento alimentario que acompaña hábitos saludables; no reemplaza una alimentación balanceada ni un tratamiento médico. Ante dudas, consulta con un profesional de la salud.'
}];
const PRICING = [{
  plan: 'Compra única',
  launch: '$79.990',
  normal: '$89.990',
  per: 'pago único',
  note: 'Tu frasco de 30 porciones.'
}, {
  plan: 'Suscripción mensual',
  launch: '$69.990',
  normal: '$79.990',
  per: '/ mes',
  note: 'Incluye el regalo de bienvenida.',
  featured: true
}, {
  plan: 'Suscripción trimestral',
  launch: '$178.474',
  normal: '$203.974',
  per: '/ cada 3 meses',
  note: 'El mejor valor por porción.'
}];
Object.assign(window, {
  LAUNCH_DATE,
  Logo,
  Aster,
  useReveal,
  useCountdown,
  Countdown,
  WaitlistForm,
  NAV,
  BENEFITS,
  FORMULA,
  FACTS,
  RITUAL,
  TESTIMONIALS,
  FAQS,
  PRICING
});

/* ============================================================
   AUREA · Landing estilo AG1 — datos + iconos
   ============================================================ */

/* ---- iconos línea fina dorada ---- */
function AgIco({
  type,
  cls = 'ico'
}) {
  const p = {
    className: cls,
    viewBox: '0 0 48 48',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.6,
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  };
  switch (type) {
    case 'leaf':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("path", {
        d: "M40 8C22 8 12 18 12 34c0 0 0 6 0 6M40 8c0 18-10 28-26 28M40 8c-2 14-8 20-14 24"
      }));
    case 'shield':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("path", {
        d: "M24 5l15 5.5V23c0 9.5-6.6 15.8-15 19-8.4-3.2-15-9.5-15-19V10.5z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M17.5 23.5l4.3 4.3 8.7-9.6"
      }));
    case 'spark':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("path", {
        d: "M24 6v12M24 30v12M6 24h12M30 24h12M12 12l7 7M29 29l7 7M36 12l-7 7M19 29l-7 7"
      }));
    case 'calm':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("circle", {
        cx: "24",
        cy: "24",
        r: "18"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M14 27c3 3 7 3 10 0s7-3 10 0"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "18",
        cy: "20",
        r: "1.3",
        fill: "currentColor",
        stroke: "none"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "30",
        cy: "20",
        r: "1.3",
        fill: "currentColor",
        stroke: "none"
      }));
    case 'drop':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("path", {
        d: "M24 5.5S36 19 36 29a12 12 0 01-24 0c0-10 12-23.5 12-23.5z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M18.5 30.5a5.5 5.5 0 005.5 5"
      }));
    case 'check':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("circle", {
        cx: "24",
        cy: "24",
        r: "18"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M16 24.5l5 5 11-12"
      }));
    case 'tick':
      return /*#__PURE__*/React.createElement("svg", {
        viewBox: "0 0 24 24",
        width: "18",
        height: "18",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: cls
      }, /*#__PURE__*/React.createElement("path", {
        d: "M5 12.5l4.5 4.5L19 7"
      }));
    case 'cross':
      return /*#__PURE__*/React.createElement("svg", {
        viewBox: "0 0 24 24",
        width: "16",
        height: "16",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "3",
        strokeLinecap: "round",
        className: cls
      }, /*#__PURE__*/React.createElement("path", {
        d: "M7 7l10 10M17 7L7 17"
      }));
    case 'no':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("circle", {
        cx: "24",
        cy: "24",
        r: "18"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M17 17l14 14M31 17L17 31"
      }));
    case 'maybe':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("circle", {
        cx: "24",
        cy: "24",
        r: "18"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M15 24h18"
      }));
    case 'flask':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("path", {
        d: "M19 6v12L9 36a4 4 0 003.5 6h23A4 4 0 0039 36L29 18V6"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M17 6h14M15 28h18"
      }));
    case 'sprout':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("path", {
        d: "M24 42V20"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M24 24c-2-8-9-9-14-9 0 7 4 12 14 12M24 20c2-6 8-7 12-7 0 6-4 10-12 10"
      }));
    case 'globe':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("circle", {
        cx: "24",
        cy: "24",
        r: "18"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M6 24h36M24 6c5 5 5 31 0 36M24 6c-5 5-5 31 0 36"
      }));
    case 'gift':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("rect", {
        x: "8",
        y: "18",
        width: "32",
        height: "22",
        rx: "2"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M6 18h36M24 18v22M24 18s-3-10-9-10a4 4 0 000 8M24 18s3-10 9-10a4 4 0 010 8"
      }));
    case 'cup':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("path", {
        d: "M10 14h24v12a12 12 0 01-24 0z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M34 16h4a4 4 0 010 8h-4M12 42h20"
      }));
    case 'microscope':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("path", {
        d: "M18 38h22M14 42h14"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M22 30l-4-4 8-10 6 6-8 8z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M26 12l4 4M20 34a10 10 0 0014-9"
      }));
    case 'pile':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("circle", {
        cx: "18",
        cy: "20",
        r: "6"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "30",
        cy: "20",
        r: "6"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "24",
        cy: "31",
        r: "6"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "18",
        cy: "20",
        r: "1.2",
        fill: "currentColor",
        stroke: "none"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "30",
        cy: "20",
        r: "1.2",
        fill: "currentColor",
        stroke: "none"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "24",
        cy: "31",
        r: "1.2",
        fill: "currentColor",
        stroke: "none"
      }));
    case 'stevia':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("path", {
        d: "M24 42V22"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M24 26c-3-7-10-8-16-7 0 7 5 12 16 12"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M24 22c2-6 8-8 14-7 0 6-4 11-14 11"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M24 16c1-4 4-6 8-6"
      }));
    case 'noartif':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("circle", {
        cx: "24",
        cy: "24",
        r: "18"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M24 14v12l7 4"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12 12l24 24",
        opacity: "0.55"
      }));
    case 'fruit':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("path", {
        d: "M30 12c0 4-3 7-7 7M31 16c5 1 9 6 9 12a13 13 0 01-26 0c0-7 5-13 13-13 1.5 0 3 .2 4 .6z"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "20",
        cy: "28",
        r: "1.2",
        fill: "currentColor",
        stroke: "none"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "27",
        cy: "32",
        r: "1.2",
        fill: "currentColor",
        stroke: "none"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "22",
        cy: "35",
        r: "1.2",
        fill: "currentColor",
        stroke: "none"
      }));
    default:
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("circle", {
        cx: "24",
        cy: "24",
        r: "16"
      }));
  }
}

/* ---- contenido ---- */
const AG = {
  rotwords: ['en calma', 'liviana', 'con energía', 'en tu mejor versión'],
  reviews: [{
    q: 'A la semana ya sentía la panza menos hinchada. Lo tomo todas las mañanas sin falta.',
    who: 'Catalina R.'
  }, {
    q: 'El sabor a maracuyá es lo que me hace no fallarle. No sabe a remedio, sabe a ritual.',
    who: 'Javiera M.'
  }, {
    q: 'Menos pesadez después de comer y la cabeza más clara a media mañana.',
    who: 'Fernanda T.'
  }, {
    q: 'Por fin algo que reemplaza los tres frascos que tomaba. Más simple imposible.',
    who: 'Antonia P.'
  }],
  contains: ['14 cepas probióticas vivas', 'Hongos adaptógenos', 'Greens & superfoods', 'Astaxantina (antioxidante)', 'Wellmune® betaglucano', 'Polifenoles vegetales', 'Fibra prebiótica'],
  // Comparativa veraz: dosis reales de AUREA (ficha técnica) vs. greens común
  compareCols: ['AUREA Greens & Superfoods', 'Greens en polvo común'],
  compare: [{
    k: 'Cepas probióticas',
    pct: '+180%',
    aurea: '14 cepas',
    other: '5 cepas'
  }, {
    k: 'Greens reales',
    sub: 'kale · spirulina · chlorella · espinaca',
    pct: '+100%',
    aurea: '2.200 mg',
    other: '1.100 mg'
  }, {
    k: 'Polifenoles',
    sub: 'maqui · semilla de uva · camu camu',
    pct: '+83%',
    aurea: '1.100 mg',
    other: '600 mg'
  }, {
    k: 'Fibra prebiótica',
    sub: 'inulina + bambú',
    pct: '+70%',
    aurea: '1.700 mg',
    other: '1.000 mg'
  }, {
    k: 'Vitamina C',
    pct: '+67%',
    aurea: '150 mg',
    other: '90 mg'
  }, {
    k: 'Betaglucano',
    excl: true,
    aurea: '250 mg',
    other: 'No incluye'
  }, {
    k: 'Astaxantina',
    excl: true,
    aurea: '2 mg',
    other: 'No incluye'
  }],
  ingredients: [{
    id: 'ag-ing-19',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_7_sept_2026_11_11_04_p.m..png?v=1788793891',
    label: 'PROBIÓTICOS',
    t: 'Mix 14 cepas',
    d: '14 cepas vivas que equilibran tu flora intestinal.'
  }, {
    id: 'ag-ing-6',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_30_jun_2026_02_54_06_a.m..png?v=1782814094',
    label: 'MICROALGA',
    t: 'Spirulina',
    d: 'Proteína vegetal y pigmentos antioxidantes.'
  }, {
    id: 'ag-ing-17',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_30_jun_2026_03_11_44_a.m..png?v=1782814099',
    label: 'ENERGÍA CALMA',
    t: 'Té matcha',
    d: 'Antioxidantes y energía sostenida, sin nervios.'
  }, {
    id: 'ag-ing-14',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_30_jun_2026_03_05_29_a.m..png?v=1782814100',
    label: 'ADAPTÓGENO',
    t: 'Reishi',
    d: 'Hongo funcional asociado al equilibrio y la calma.'
  }, {
    id: 'ag-ing-16',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_30_jun_2026_03_09_49_a.m..png?v=1782814096',
    label: 'ADAPTÓGENO',
    t: 'Melena de león',
    d: 'Hongo asociado al foco y la claridad mental.'
  }, {
    id: 'ag-ing-8',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_30_jun_2026_02_04_20_a.m..png?v=1782814098',
    label: 'SUPERFRUTA',
    t: 'Maqui',
    d: 'Baya patagónica de altísimo poder antioxidante.'
  }, {
    id: 'ag-ing-1',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_30_jun_2026_01_59_07_a.m..png?v=1782814099',
    label: 'PREBIÓTICO',
    t: 'Inulina',
    d: 'Fibra prebiótica que alimenta tu microbiota.'
  }, {
    id: 'ag-ing-21',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_30_jun_2026_03_15_38_a.m..png?v=1782814096',
    label: 'ANTIOXIDANTE',
    t: 'Astaxantina',
    d: 'Pigmento rojo de microalga, antioxidante celular.'
  }, {
    id: 'ag-ing-12',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_30_jun_2026_02_08_05_a.m..png?v=1782814100',
    label: 'VITAMINA C',
    t: 'Camu camu',
    d: 'Fruto amazónico, fuente natural de vitamina C.'
  }, {
    id: 'ag-ing-3',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_30_jun_2026_02_31_28_a.m..png?v=1782814100',
    label: 'GREENS',
    t: 'Kale',
    d: 'Hoja verde rica en clorofila y micronutrientes.'
  }, {
    id: 'ag-ing-2',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_30_jun_2026_02_28_47_a.m..png?v=1782814098',
    label: 'FIBRA VEGETAL',
    t: 'Fibra de bambú',
    d: 'Fibra natural que aporta saciedad y regularidad.'
  }, {
    id: 'ag-ing-4',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_30_jun_2026_02_45_19_a.m..png?v=1782814098',
    label: 'MICROALGA',
    t: 'Chlorella',
    d: 'Microalga verde, rica en clorofila y fitonutrientes.'
  }, {
    id: 'ag-ing-5',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ESPINACA.png?v=1782814100',
    label: 'GREENS',
    t: 'Espinaca',
    d: 'Verde suave que aporta minerales y antioxidantes.'
  }, {
    id: 'ag-ing-7',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/uva.png?v=1782814098',
    label: 'ANTIOXIDANTE',
    t: 'Semilla de uva',
    d: 'Polifenoles (OPC) frente al estrés oxidativo.'
  }, {
    id: 'ag-ing-9',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_30_jun_2026_02_59_34_a.m..png?v=1782814099',
    label: 'ANTIOXIDANTE',
    t: 'Zanahoria',
    d: 'Betacarotenos que aportan al cuidado de la piel.'
  }, {
    id: 'ag-ing-10',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_30_jun_2026_02_11_24_a.m..png?v=1782814100',
    label: 'DIGESTIVO',
    t: 'Jengibre',
    d: 'Raíz que acompaña la digestión y la vitalidad.'
  }, {
    id: 'ag-ing-11',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_30_jun_2026_03_01_48_a.m..png?v=1782814100',
    label: 'DEFENSAS',
    t: 'Betaglucano',
    d: 'Betaglucano que acompaña tu sistema inmune.'
  }, {
    id: 'ag-ing-13',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/vit_c.png?v=1782814099',
    label: 'DEFENSAS',
    t: 'Vitamina C',
    d: 'Contribuye al sistema inmune y a la formación de colágeno.'
  }, {
    id: 'ag-ing-15',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_30_jun_2026_03_07_22_a.m..png?v=1782814097',
    label: 'ADAPTÓGENO',
    t: 'Cordyceps',
    d: 'Hongo asociado a la energía y la resistencia.'
  }, {
    id: 'ag-ing-20',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_30_jun_2026_03_21_19_a.m..png?v=1782814098',
    label: 'ENDULZANTE',
    t: 'Stevia',
    d: 'Dulzor natural, sin azúcar ni edulcorantes artificiales.'
  }],
  seals: [{
    ico: 'pile',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/20-activos.png?v=1787898302',
    t: 'Más de 20 activos en una toma'
  }, {
    ico: 'probiotic',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/14-cepas.png?v=1787898305',
    t: '14 cepas probióticas vivas'
  }, {
    ico: 'stevia',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/stevia.png?v=1787900192',
    t: 'Endulzado solo con stevia'
  }, {
    ico: 'fruit',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/seal-fruta.png?v=1787900811',
    t: 'Sabor maracuyá & piña'
  }, {
    ico: 'flask',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/haccp-gmp.png?v=1787900345',
    t: 'Formulado en Chile · HACCP/GMP'
  }],
  steps: [{
    n: '01',
    t: 'Sirve',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/paso_1.png?v=1782814094',
    d: 'Una porción (7,79 g) en 200–250 ml de agua fría, en tu termo mezclador AUREA.'
  }, {
    n: '02',
    t: 'Agita',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/mezcla.png?v=1782814094',
    d: 'Tapa y agita 10 segundos. Se disuelve en segundos, con sabor a maracuyá y piña.'
  }, {
    n: '03',
    t: 'Disfruta',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/listo.png?v=1782814100',
    d: 'Bébelo en ayunas o cuando lo necesites. Un minuto para ti, cada día.'
  }],
  benefits: [{
    key: 'Apoyo digestivo',
    ico: 'leaf',
    title: 'Digestión en calma',
    lead: 'Una mezcla de 14 cepas probióticas y fibra vegetal acompaña a tu microbiota para que tu abdomen se sienta más liviano día a día.',
    sci: 'Los probióticos y la fibra prebiótica ayudan a nutrir y equilibrar la microbiota intestinal, base de una digestión serena.',
    quote: 'Mi digestión se siente distinta. Menos hinchazón, menos pesadez.',
    who: 'Catalina R. · Beta tester'
  }, {
    key: 'Defensas & brillo',
    ico: 'shield',
    title: 'Defensas y vitalidad',
    lead: 'Wellmune® betaglucano y astaxantina, dos activos premium que apoyan tus defensas y tu brillo natural desde adentro.',
    sci: 'El betaglucano es un activo clínicamente estudiado para apoyar el sistema inmune; la astaxantina es un antioxidante asociado a la vitalidad celular.',
    quote: 'La piel y el pelo lo agradecen. Me siento con más vitalidad.',
    who: 'Nichol B. · Beta tester'
  }, {
    key: 'Energía & claridad',
    ico: 'spark',
    title: 'Energía y mente clara',
    lead: 'Cuando tu interior está en equilibrio, la cabeza también respira. El eje intestino–mente es real.',
    sci: 'El bienestar digestivo se asocia a una mejor sensación de energía y claridad mental a lo largo del día.',
    quote: 'Energía pareja toda la mañana, sin el bajón de media tarde.',
    who: 'Valarie A. · Beta tester'
  }, {
    key: 'Calma & equilibrio',
    ico: 'calm',
    title: 'Calma y equilibrio',
    lead: 'Los hongos adaptógenos apoyan la respuesta de tu cuerpo al estrés, para una sensación de calma sostenida.',
    sci: 'Los adaptógenos son ingredientes botánicos tradicionalmente usados para acompañar el equilibrio ante el estrés cotidiano.',
    quote: 'Siento el día más manejable. Una calma sutil pero real.',
    who: 'Eric T. · Beta tester'
  }],
  // kit / precios (CLP) — valores de regalo referenciales
  kit: {
    mainName: 'Superfood AUREA',
    mainSub: '30 porciones · tu ritual mensual',
    mainPrice: '$69.990',
    items: [{
      ico: 'cup',
      b: 'Termo mezclador AUREA',
      p: 'Termo de alta calidad, en blanco',
      was: '$14.990'
    }, {
      ico: 'drop',
      b: 'Vitamina D3 + K2 · 30 cápsulas',
      p: 'El complemento para tus defensas',
      was: '$13.990'
    }, {
      ico: 'gift',
      b: 'Envío gratis',
      p: 'Entrega con cada despacho',
      was: '$4.990'
    }],
    totalWas: '$103.960',
    totalNow: '$69.990'
  },
  longReviews: [{
    stars: '★★★★★',
    h: 'Me siento liviana de nuevo',
    p: 'Llevaba años con la barriga hinchada después de cada comida. Con AUREA, por primera vez, cierro el día sin esa incomodidad. Volví a usar la ropa que me gusta.',
    who: 'Camila R.'
  }, {
    stars: '★★★★★',
    h: 'Reemplazó mis tres frascos',
    p: 'Tomaba probiótico, greens y un antioxidante por separado. AUREA los juntó en una sola toma que además sabe rico. Más simple y más barato.',
    who: 'Antonia P.'
  }, {
    stars: '★★★★★',
    h: 'Mi ritual favorito',
    p: 'No es solo un suplemento, es el minuto que me dedico cada mañana. El sabor a maracuyá hace que lo espere con ganas. Mi intestino y mi cabeza lo notan.',
    who: 'Javiera M.'
  }],
  quality: [{
    ico: 'microscope',
    t: 'Impulsado por la ciencia, respaldado por la investigación',
    d: 'Cada activo se elige por su evidencia y en formas que tu cuerpo pueda aprovechar de verdad.'
  }, {
    ico: 'shield',
    t: 'Activos de marca registrada',
    d: 'Como Wellmune® betaglucano, respaldado por estudios clínicos y con trazabilidad completa.'
  }, {
    ico: 'check',
    t: 'Pensado para lo que importa',
    d: 'Una fórmula enfocada en tu digestión, tu calma y tu energía —no en sumar ingredientes de relleno.'
  }, {
    ico: 'sprout',
    t: 'Ingredientes que tu cuerpo reconoce',
    d: 'Seleccionados por su pureza y calidad, sin colorantes ni edulcorantes artificiales.'
  }, {
    ico: 'fruit',
    t: 'Sabe bien todos los días',
    d: 'Maracuyá y piña, endulzado solo con stevia: un ritual que dan ganas de repetir.'
  }],
  faqs: [{
    q: '¿Qué es AUREA Greens & Superfoods?',
    a: 'Es un batido diario de greens y superfoods con una cepa de 14 probióticos, hongos adaptógenos, astaxantina, Wellmune® betaglucano, greens y polifenoles. Acompaña tu bienestar digestivo y mental, con sabor maracuyá y piña, endulzado solo con stevia.'
  }, {
    q: '¿Cómo y cuándo lo tomo?',
    a: 'Una porción de 7,79 g disuelta en 200–250 ml de agua fría, idealmente en ayunas o cuando lo necesites. Lo ideal es prepararlo en tu termo mezclador AUREA.'
  }, {
    q: '¿A qué suplementos reemplaza?',
    a: 'AUREA reúne en una sola toma lo que normalmente comprarías por separado: probiótico, adaptógenos, greens, antioxidantes, betaglucano y fibra. Menos frascos, más simple.'
  }, {
    q: '¿Qué incluye el kit de bienvenida?',
    a: 'Al suscribirte recibes de regalo un termo mezclador AUREA en blanco y un frasco de Vitamina D3+K2 (30 cápsulas), además del envío incluido.'
  }, {
    q: '¿Qué gano si me sumo a la Lista Dorada?',
    a: 'Acceso al checkout 24 horas antes que el público general y un precio exclusivo de lanzamiento congelado para ti por 24 meses. Te avisamos por correo apenas abramos.'
  }, {
    q: '¿Puedo cancelar la suscripción cuando quiera?',
    a: 'Sí. La suscripción es flexible: puedes pausarla o cancelarla cuando lo necesites. Tu precio de lanzamiento se mantiene mientras tu suscripción siga activa.'
  }, {
    q: '¿AUREA reemplaza una alimentación equilibrada?',
    a: 'No. Es un suplemento alimentario que acompaña hábitos saludables; no reemplaza una alimentación balanceada ni un tratamiento médico. Ante dudas, consulta con un profesional de la salud.'
  }],
  facts: {
    serving: '5 scoops · aprox. 7,79 g',
    servings: '30 porciones por envase',
    net: 'Contenido neto: 234 g',
    nutrition: [{
      k: 'Energía',
      portion: '20,6 kcal',
      per100: '264 kcal',
      ddr: ''
    }, {
      k: 'Proteínas',
      portion: '0,9 g',
      per100: '12,1 g',
      ddr: ''
    }, {
      k: 'Grasa total',
      portion: '0,2 g',
      per100: '2,4 g',
      ddr: ''
    }, {
      k: 'Hidratos de carbono',
      portion: '3,8 g',
      per100: '48,5 g',
      ddr: ''
    }, {
      k: 'Azúcares totales',
      portion: '2,1 g',
      per100: '27,1 g',
      ddr: ''
    }, {
      k: 'Fibra vegetal',
      portion: '2,1 g',
      per100: '26,6 g',
      ddr: ''
    }, {
      k: 'Sodio',
      portion: '12,7 mg',
      per100: '163 mg',
      ddr: ''
    }, {
      k: 'Vitamina C',
      portion: '150 mg',
      per100: '1.927 mg',
      ddr: '250%'
    }],
    actives: [['Inulina', '1.000 mg'], ['Fibra de bambú', '700 mg'], ['Kale', '550 mg'], ['Chlorella', '550 mg'], ['Espinaca', '550 mg'], ['Spirulina', '550 mg'], ['Semilla de uva', '500 mg'], ['Maqui', '400 mg'], ['Zanahoria', '300 mg'], ['Jengibre', '300 mg'], ['Betaglucano', '250 mg'], ['Camu camu', '200 mg'], ['Vitamina C', '150 mg'], ['Reishi', '135 mg'], ['Cordyceps militaris', '135 mg'], ['Melena de león', '130 mg'], ['Té matcha', '100 mg'], ['Lecitina de maravilla', '100 mg'], ['Mix probiótico (14 cepas)', '75 mg'], ['Stevia', '30 mg'], ['Astaxantina', '2 mg']],
    probioticTotal: '≈ 1,47 × 10¹⁰ UFC por porción',
    strains: 'Lactobacillus plantarum, L. acidophilus, L. casei, L. johnsonii, L. rhamnosus, L. paracasei, L. bulgaricus, L. salivarius, Bifidobacterium longum, B. lactis, B. breve, B. bifidum, Bacillus coagulans y B. subtilis.',
    ingredients: 'Inulina, fibra de bambú, kale, chlorella, espinaca, spirulina, saborizante maracuyá idéntico al natural, semilla de uva (Vitis vinifera), maqui (Aristotelia chilensis), zanahoria, jengibre molido, ácido cítrico, betaglucano, camu camu, vitamina C (ácido ascórbico), reishi, Cordyceps militaris, melena de león (Hericium erinaceus), té matcha, dióxido de silicio, lecitina de maravilla, astaxantina microencapsulada (Haematococcus pluvialis), mix probióticos (14 cepas), saborizante piña idéntico al natural, stevia.',
    use: 'Consumir una porción disuelta en 200 ml de agua, o según indicación profesional competente. Recomendación máxima de consumo diario: una porción.',
    allergens: 'Elaborado y envasado en líneas que también procesan nueces, maní, soya, gluten y derivados del pescado.',
    legal: 'Suplemento Alimentario. “Su uso no es recomendable para consumo por menores de 8 años, embarazadas y nodrizas, salvo indicación profesional competente y no reemplaza a una alimentación balanceada.” Res. SEREMI R.M. de Salud N°1613366774. Elaborado en Chile.'
  }
};
Object.assign(window, {
  AgIco,
  AG
});

/* ============================================================
   AUREA · Landing estilo AG1 — secciones + app
   Reusa de aurea-data.jsx: Logo, WaitlistForm, useReveal
   ============================================================ */

const AG_NAV = [{
  href: '#rutina',
  label: 'Beneficios'
}, {
  href: '#formula',
  label: 'Qué contiene'
}, {
  href: '#ingredientes',
  label: 'Ingredientes'
}, {
  href: '#kit',
  label: 'Kit de bienvenida'
}, {
  href: '#preguntas',
  label: 'Preguntas'
}];

/* ---------------- HEADER ---------------- */
function AgHeader() {
  const [menu, setMenu] = React.useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "ag-announce"
  }, "Lanzamiento en Chile \xB7 ", /*#__PURE__*/React.createElement("b", null, "Lista Dorada"), ": acceso anticipado + precio congelado 24 meses"), /*#__PURE__*/React.createElement("header", {
    className: "ag-head"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#inicio",
    "aria-label": "AUREA inicio"
  }, /*#__PURE__*/React.createElement(Logo, {
    variant: "gold",
    height: 40
  })), /*#__PURE__*/React.createElement("nav", {
    className: "ag-nav"
  }, AG_NAV.map(n => /*#__PURE__*/React.createElement("a", {
    key: n.href,
    href: n.href
  }, n.label))), /*#__PURE__*/React.createElement("button", {
    className: "menu-btn",
    "aria-label": "Men\xFA",
    onClick: () => setMenu(true)
  }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null))), menu && /*#__PURE__*/React.createElement("div", {
    className: "ag-mobile",
    onClick: () => setMenu(false)
  }, /*#__PURE__*/React.createElement("nav", {
    onClick: e => e.stopPropagation()
  }, AG_NAV.map(n => /*#__PURE__*/React.createElement("a", {
    key: n.href,
    href: n.href,
    onClick: () => setMenu(false)
  }, n.label)), /*#__PURE__*/React.createElement("a", {
    href: "about.html"
  }, "Nosotros"), /*#__PURE__*/React.createElement("a", {
    className: "btn btn-gold",
    href: "#kit",
    onClick: () => setMenu(false)
  }, "Unirme a la Lista Dorada"))));
}

/* ---------------- HERO ---------------- */
function AgHero() {
  const [wi, setWi] = React.useState(0);
  React.useEffect(() => {
    const id = setInterval(() => setWi(i => (i + 1) % AG.rotwords.length), 2200);
    return () => clearInterval(id);
  }, []);
  return /*#__PURE__*/React.createElement("header", {
    className: "ag-hero",
    id: "inicio"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ag-hero-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ag-hero-text-in ag-hero-copy"
  }, /*#__PURE__*/React.createElement("h1", null, "Estamos aqu\xED para que te sientas ", /*#__PURE__*/React.createElement("span", {
    className: "rot"
  }, AG.rotwords[wi])), /*#__PURE__*/React.createElement("p", {
    className: "sub"
  }, "AUREA es tu batido diario con 14 cepas probi\xF3ticas, adapt\xF3genos y superfoods \u2014para apoyar tu digesti\xF3n, tu energ\xEDa y tu calma desde adentro."), /*#__PURE__*/React.createElement("div", {
    className: "hero-cta"
  }, /*#__PURE__*/React.createElement("a", {
    className: "btn btn-gold btn-gold-metal",
    href: "#kit"
  }, "S\xE9 de las primeras en Chile ", /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\u2192"))))), /*#__PURE__*/React.createElement("div", {
    className: "ag-hero-img"
  }, /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("source", {
    media: "(max-width: 767px)",
    srcSet: "https://cdn.shopify.com/s/files/1/0991/4302/4929/files/aureasivriendose-1.png?v=1788360006"
  }), /*#__PURE__*/React.createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_2_jul_2026_02_21_32_a.m..png?v=1782930149",
    alt: "Productos AUREA",
    className: "ag-hero-photo"
  }))));
}

/* ---------------- REVIEW STRIP ---------------- */
function AgReviewStrip() {
  return /*#__PURE__*/React.createElement("section", {
    className: "ag-reviews-strip"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "count reveal"
  }, /*#__PURE__*/React.createElement("span", {
    className: "stars"
  }, "\u2605\u2605\u2605\u2605\u2605"), "Lo que dicen quienes ya lo probaron"), /*#__PURE__*/React.createElement("div", {
    className: "ag-rev-quotes"
  }, AG.reviews.map((r, i) => /*#__PURE__*/React.createElement("figure", {
    className: "ag-rev-q reveal",
    key: i,
    style: {
      transitionDelay: i * 70 + 'ms'
    }
  }, /*#__PURE__*/React.createElement("p", null, "\u201C", r.q, "\u201D"), /*#__PURE__*/React.createElement("figcaption", {
    className: "who"
  }, /*#__PURE__*/React.createElement("span", {
    className: "st"
  }, "\u2605\u2605\u2605\u2605\u2605"), r.who))))));
}

/* ---------------- REEMPLAZA ---------------- */
function AgReplace() {
  return /*#__PURE__*/React.createElement("section", {
    className: "ag-replace",
    id: "formula"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ag-replace-head reveal"
  }, /*#__PURE__*/React.createElement("h2", null, "El nuevo ", /*#__PURE__*/React.createElement("em", null, "est\xE1ndar dorado.")), /*#__PURE__*/React.createElement("p", {
    className: "body"
  }, "Mira c\xF3mo se compara AUREA frente a un greens en polvo com\xFAn: en dosis reales, transparencia de ingredientes y formulaci\xF3n completa.")), /*#__PURE__*/React.createElement("div", {
    className: "ag-cmp reveal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ag-cmp-grid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ag-cmp-cell ag-cmp-h ag-cmp-h0"
  }, "Ingrediente"), /*#__PURE__*/React.createElement("div", {
    className: "ag-cmp-cell ag-cmp-h ag-cmp-h1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ag-cmp-pic"
  }, /*#__PURE__*/React.createElement("image-slot", {
    id: "ag-cmp-aurea",
    class: "ag-slot",
    shape: "rect",
    fit: "contain",
    src: AUREA_ASSET("pote.png"),
    placeholder: "Foto AUREA"
  })), /*#__PURE__*/React.createElement("span", {
    className: "ag-cmp-brand"
  }, /*#__PURE__*/React.createElement(Logo, { variant: "gold", height: 26 }))), /*#__PURE__*/React.createElement("div", {
    className: "ag-cmp-cell ag-cmp-h ag-cmp-h2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ag-cmp-pic ag-cmp-pic-other"
  }, /*#__PURE__*/React.createElement("image-slot", {
    id: "ag-cmp-other",
    class: "ag-slot",
    shape: "rect",
    fit: "contain",
    src: AUREA_ASSET("greens-comun.png"),
    placeholder: "Greens com\xFAn"
  })), /*#__PURE__*/React.createElement("span", {
    className: "ag-cmp-other-label"
  }, "Greens com\xFAn")), AG.compare.map((r, i) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: i
  }, /*#__PURE__*/React.createElement("div", {
    className: "ag-cmp-cell ag-cmp-c0"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ag-cmp-k"
  }, r.k), r.sub ? /*#__PURE__*/React.createElement("span", {
    className: "ag-cmp-sub"
  }, r.sub) : null), /*#__PURE__*/React.createElement("div", {
    className: 'ag-cmp-cell ag-cmp-c1' + (i === AG.compare.length - 1 ? ' ag-cmp-last' : '')
  }, /*#__PURE__*/React.createElement("span", {
    className: "ag-cmp-circle gold"
  }, /*#__PURE__*/React.createElement(AgIco, {
    type: "tick",
    cls: ""
  })), /*#__PURE__*/React.createElement("div", {
    className: "ag-cmp-val"
  }, r.excl ? /*#__PURE__*/React.createElement("span", {
    className: "ag-cmp-excl"
  }, "Exclusivo") : /*#__PURE__*/React.createElement("span", {
    className: "ag-cmp-pct"
  }, r.pct), /*#__PURE__*/React.createElement("span", {
    className: "ag-cmp-dose"
  }, r.aurea))), /*#__PURE__*/React.createElement("div", {
    className: "ag-cmp-cell ag-cmp-c2"
  }, r.other === 'No incluye' ? /*#__PURE__*/React.createElement("span", {
    className: "ag-cmp-circle no"
  }, /*#__PURE__*/React.createElement(AgIco, {
    type: "cross",
    cls: ""
  })) : /*#__PURE__*/React.createElement("span", {
    className: "ag-cmp-circle mut"
  }, /*#__PURE__*/React.createElement(AgIco, {
    type: "tick",
    cls: ""
  })), /*#__PURE__*/React.createElement("span", {
    className: "ag-cmp-otherval"
  }, r.other)))))), /*#__PURE__*/React.createElement("p", {
    className: "ag-cmp-foot reveal"
  }, /*#__PURE__*/React.createElement("b", null, "Dosis de AUREA seg\xFAn su ficha t\xE9cnica oficial."), " \u201CGreens com\xFAn\u201D corresponde al promedio de un suplemento de greens en polvo comparable disponible en Chile; porcentajes calculados sobre esas cantidades por porci\xF3n.")));
}

/* ---------------- SELLOS ---------------- */
function AgSeals() {
  return /*#__PURE__*/React.createElement("section", {
    className: "ag-seals"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ag-seals-grid reveal"
  }, AG.seals.map((s, i) => /*#__PURE__*/React.createElement("div", {
    className: "ag-seal",
    key: i
  }, s.img ? /*#__PURE__*/React.createElement("img", {
    className: "ag-seal-img",
    src: s.img,
    alt: "",
    loading: "lazy"
  }) : /*#__PURE__*/React.createElement(AgIco, {
    type: s.ico
  }), /*#__PURE__*/React.createElement("span", null, s.t))))));
}

/* ---------------- ALIMENTA TU DÍA (rutina · cards con glass) ---------------- */
const AG_ROUTINE = [{
  id: 'ag-r3',
  t: 'Digestión regular',
  img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_28_jun_2026_07_12_44_p.m..png?v=1782817707',
  d: 'Las 14 cepas probióticas y la fibra prebiótica cuidan tu microbiota para una digestión más liviana.'
}, {
  id: 'ag-r2',
  t: 'Defensa inmunitaria',
  img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_29_jun_2026_12_04_01_a.m..png?v=1782814206',
  d: 'El Wellmune® betaglucano, un activo clínicamente estudiado, apoya la función de tu sistema inmunológico.'
}, {
  id: 'ag-r1',
  t: 'Energía y claridad',
  img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_29_jun_2026_08_29_15_p.m..png?v=1782814205',
  d: 'Los greens y superfoods, junto al eje intestino–mente, apoyan tu energía y concentración a lo largo del día.'
}, {
  id: 'ag-r4',
  t: 'Calma y equilibrio',
  img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/pexels-mikhail-nilov-6707027.jpg?v=1782927360',
  d: 'Los hongos adaptógenos apoyan la respuesta de tu cuerpo al estrés y la sensación de calma.'
}, {
  id: 'ag-r5',
  t: 'Huesos y vitalidad',
  img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/pexels-shvets-production-8417437.jpg?v=1782927832',
  d: 'La Vitamina D3 + K2 de tu kit contribuye al mantenimiento de huesos normales y a tus defensas.'
}, {
  id: 'ag-r6',
  t: 'Piel, cabello y brillo',
  img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_28_jun_2026_08_46_35_p.m..png?v=1782814205',
  d: 'La astaxantina y los polifenoles, antioxidantes, apoyan tu piel, cabello y brillo natural.'
}];
function AgFactsModal({
  onClose
}) {
  const f = AG.facts;
  React.useEffect(() => {
    const onKey = e => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);
  return /*#__PURE__*/React.createElement("div", {
    className: "ag-modal",
    onClick: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "ag-modal-card",
    role: "dialog",
    "aria-modal": "true",
    "aria-label": "Informaci\xF3n nutricional",
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React.createElement("button", {
    className: "ag-modal-x",
    "aria-label": "Cerrar",
    onClick: onClose
  }, "\xD7"), /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, "AUREA Greens & Superfoods"), /*#__PURE__*/React.createElement("h3", {
    className: "ag-modal-title"
  }, "Informaci\xF3n nutricional"), /*#__PURE__*/React.createElement("div", {
    className: "ag-facts-meta"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "Porci\xF3n"), /*#__PURE__*/React.createElement("b", null, f.serving)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "Envase"), /*#__PURE__*/React.createElement("b", null, f.servings)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "Neto"), /*#__PURE__*/React.createElement("b", null, f.net.replace('Contenido neto: ', '')))), /*#__PURE__*/React.createElement("table", {
    className: "ag-facts-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Nutriente"), /*#__PURE__*/React.createElement("th", null, "Porci\xF3n"), /*#__PURE__*/React.createElement("th", null, "100 g"))), /*#__PURE__*/React.createElement("tbody", null, f.nutrition.map((n, i) => /*#__PURE__*/React.createElement("tr", {
    key: i
  }, /*#__PURE__*/React.createElement("td", null, n.k, n.ddr ? /*#__PURE__*/React.createElement("span", {
    className: "ddr"
  }, " \xB7 ", n.ddr, " DDR") : null), /*#__PURE__*/React.createElement("td", {
    className: "amt"
  }, n.portion), /*#__PURE__*/React.createElement("td", {
    className: "per100"
  }, n.per100))))), /*#__PURE__*/React.createElement("h4", {
    className: "ag-facts-h"
  }, "Componentes activos ", /*#__PURE__*/React.createElement("span", null, "por porci\xF3n")), /*#__PURE__*/React.createElement("ul", {
    className: "ag-facts-actives"
  }, f.actives.map((a, i) => /*#__PURE__*/React.createElement("li", {
    key: i
  }, /*#__PURE__*/React.createElement("span", {
    className: "n"
  }, a[0]), /*#__PURE__*/React.createElement("span", {
    className: "v"
  }, a[1])))), /*#__PURE__*/React.createElement("h4", {
    className: "ag-facts-h"
  }, "Mezcla probi\xF3tica \xB7 14 cepas"), /*#__PURE__*/React.createElement("p", {
    className: "ag-facts-text"
  }, /*#__PURE__*/React.createElement("b", null, f.probioticTotal, "."), " ", f.strains), /*#__PURE__*/React.createElement("h4", {
    className: "ag-facts-h"
  }, "Ingredientes"), /*#__PURE__*/React.createElement("p", {
    className: "ag-facts-text"
  }, f.ingredients), /*#__PURE__*/React.createElement("h4", {
    className: "ag-facts-h"
  }, "Modo de uso"), /*#__PURE__*/React.createElement("p", {
    className: "ag-facts-text"
  }, f.use), /*#__PURE__*/React.createElement("p", {
    className: "ag-facts-note"
  }, /*#__PURE__*/React.createElement("b", null, "Al\xE9rgenos:"), " ", f.allergens), /*#__PURE__*/React.createElement("p", {
    className: "ag-facts-note"
  }, f.legal)));
}
function AgRoutine() {
  const [factsOpen, setFactsOpen] = React.useState(false);
  const rowRef = React.useRef(null);
  const scroll = dir => {
    const row = rowRef.current;
    if (!row) return;
    const card = row.querySelector('.ag-rcard');
    const step = (card ? card.getBoundingClientRect().width + 18 : 320) * dir;
    const start = row.scrollLeft;
    const target = Math.max(0, Math.min(start + step, row.scrollWidth - row.clientWidth));
    const t0 = performance.now();
    const dur = 420;
    const ease = t => 1 - Math.pow(1 - t, 3);
    const tick = now => {
      const p = Math.min(1, (now - t0) / dur);
      row.scrollLeft = start + (target - start) * ease(p);
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };
  return /*#__PURE__*/React.createElement("section", {
    className: "section ag-routine",
    id: "rutina"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ag-routine-head reveal"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "ag-routine-title"
  }, "Alimenta tu d\xEDa con una ", /*#__PURE__*/React.createElement("span", {
    className: "hl"
  }, "rutina que funcione.")), /*#__PURE__*/React.createElement("div", {
    className: "ag-routine-subrow"
  }, /*#__PURE__*/React.createElement("p", {
    className: "ag-routine-sub"
  }, "AUREA est\xE1 dise\xF1ado para ", /*#__PURE__*/React.createElement("strong", { style: { fontWeight: 600 } }, "apoyar tu nutrici\xF3n diaria y ayudarte a sentirte de lo mejor"), ". Cada porci\xF3n combina m\xE1s de 20 activos de alta calidad \u2014probi\xF3ticos, adapt\xF3genos, greens, antioxidantes y polifenoles\u2014 seleccionados por su potencia, absorci\xF3n y sinergia."), /*#__PURE__*/React.createElement("button", {
    className: "ag-routine-facts",
    type: "button",
    onClick: () => setFactsOpen(true)
  }, /*#__PURE__*/React.createElement("span", {
    className: "plus"
  }, "+"), " Ver tabla nutricional"))), /*#__PURE__*/React.createElement("div", {
    className: "ag-routine-cards",
    ref: rowRef
  }, AG_ROUTINE.map((c, i) => /*#__PURE__*/React.createElement("article", {
    className: "ag-rcard reveal",
    key: c.id,
    style: {
      transitionDelay: i * 70 + 'ms'
    }
  }, /*#__PURE__*/React.createElement("image-slot", {
    id: c.id,
    class: "ag-slot",
    shape: "rect",
    fit: "cover",
    src: c.img,
    placeholder: "Beneficio"
  }), /*#__PURE__*/React.createElement("div", {
    className: "glass"
  }, /*#__PURE__*/React.createElement("h3", null, c.t), /*#__PURE__*/React.createElement("p", null, c.d))))), /*#__PURE__*/React.createElement("div", {
    className: "ag-routine-nav"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": "Anterior",
    onClick: () => scroll(-1)
  }, "\u2039"), /*#__PURE__*/React.createElement("button", {
    "aria-label": "Siguiente",
    onClick: () => scroll(1)
  }, "\u203A"))), factsOpen && /*#__PURE__*/React.createElement(AgFactsModal, {
    onClose: () => setFactsOpen(false)
  }));
}
function AgIngredients() {
  const secRef = React.useRef(null);
  const [run, setRun] = React.useState(false);
  React.useEffect(() => {
    const el = secRef.current;
    if (!el) return;
    if (!('IntersectionObserver' in window)) {
      setRun(true);
      return;
    }
    const io = new IntersectionObserver(es => {
      es.forEach(e => {
        if (e.isIntersecting) {
          setRun(true);
          io.disconnect();
        }
      });
    }, {
      threshold: 0.2
    });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  const cards = AG.ingredients.slice(0, 10);
  const renderSet = p => /*#__PURE__*/React.createElement(React.Fragment, null, cards.map(c => /*#__PURE__*/React.createElement("article", {
    className: "ag-ing-card",
    key: p + c.id,
    "aria-hidden": p === 'b' ? 'true' : undefined
  }, /*#__PURE__*/React.createElement("img", {
    src: c.img,
    alt: c.t,
    className: "ag-ing-img"
  }), /*#__PURE__*/React.createElement("span", {
    className: "ag-ing-label"
  }, c.label), /*#__PURE__*/React.createElement("div", {
    className: "ag-ing-glass"
  }, /*#__PURE__*/React.createElement("h3", null, c.t), /*#__PURE__*/React.createElement("p", null, c.d)))), /*#__PURE__*/React.createElement("a", {
    className: "ag-ing-card ag-ing-more",
    href: "ingredientes.html",
    key: p + 'more',
    "aria-hidden": p === 'b' ? 'true' : undefined
  }, /*#__PURE__*/React.createElement("span", {
    className: "ag-ing-more-arrow",
    "aria-hidden": "true"
  }, "\u2192"), /*#__PURE__*/React.createElement("span", {
    className: "ag-ing-more-txt"
  }, "Ver todos los ingredientes")));
  return /*#__PURE__*/React.createElement("section", {
    className: "section ag-ing",
    id: "ingredientes",
    ref: secRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ag-ing-head reveal"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "ag-ing-title"
  }, "M\xE1s de 20 activos,", /*#__PURE__*/React.createElement("br", {
    className: "m-br"
  }), " en ", /*#__PURE__*/React.createElement("span", {
    className: "hl"
  }, "una sola toma.")), /*#__PURE__*/React.createElement("div", {
    className: "ag-ing-subrow"
  }, /*#__PURE__*/React.createElement("p", {
    className: "ag-ing-sub"
  }, "Cada ingrediente fue elegido por una raz\xF3n. Esto es lo que llevas contigo cada d\xEDa.")))), /*#__PURE__*/React.createElement("div", {
    className: "ag-ing-marquee"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'ag-ing-track' + (run ? ' is-running' : '')
  }, renderSet('a'), renderSet('b'))));
}
function AgHow() {
  return /*#__PURE__*/React.createElement("section", {
    className: "section ag-how"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-head reveal"
  }, /*#__PURE__*/React.createElement("h2", null, "Un minuto.", /*#__PURE__*/React.createElement("br", {
    className: "m-br"
  }), " ", /*#__PURE__*/React.createElement("span", {
    className: "hl"
  }, "Tres simples pasos."))), /*#__PURE__*/React.createElement("div", {
    className: "ag-how-steps"
  }, AG.steps.map((s, i) => /*#__PURE__*/React.createElement("article", {
    className: "ag-step reveal",
    key: s.n,
    style: {
      transitionDelay: i * 90 + 'ms'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "ag-step-img"
  }, /*#__PURE__*/React.createElement("image-slot", {
    id: 'ag-how-' + s.n,
    class: "ag-slot",
    shape: "rect",
    fit: "cover",
    src: s.img,
    placeholder: 'Paso ' + s.n
  })), /*#__PURE__*/React.createElement("div", {
    className: "ag-step-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "n"
  }, s.n), /*#__PURE__*/React.createElement("h3", null, s.t), /*#__PURE__*/React.createElement("p", null, s.d)))))));
}

/* ---------------- BENEFICIOS (tabs) ---------------- */
function AgBenefits() {
  const [i, setI] = React.useState(0);
  const b = AG.benefits[i];
  return /*#__PURE__*/React.createElement("section", {
    className: "section ag-benefits",
    id: "beneficios"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-head reveal"
  }, /*#__PURE__*/React.createElement("h2", null, "Equilibrio que se siente, dentro y fuera.")), /*#__PURE__*/React.createElement("div", {
    className: "ag-ben-layout"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ag-ben-tabs reveal",
    role: "tablist"
  }, AG.benefits.map((x, xi) => /*#__PURE__*/React.createElement("button", {
    key: xi,
    role: "tab",
    "aria-selected": xi === i,
    className: 'ag-ben-tab' + (xi === i ? ' on' : ''),
    onClick: () => setI(xi)
  }, x.key))), /*#__PURE__*/React.createElement("div", {
    className: "ag-ben-panel",
    key: i
  }, /*#__PURE__*/React.createElement(AgIco, {
    type: b.ico,
    cls: "ico"
  }), /*#__PURE__*/React.createElement("h3", null, b.title), /*#__PURE__*/React.createElement("p", {
    className: "lead"
  }, b.lead), /*#__PURE__*/React.createElement("p", {
    className: "sci"
  }, b.sci), /*#__PURE__*/React.createElement("div", {
    className: "quote"
  }, /*#__PURE__*/React.createElement("p", null, "\u201C", b.quote, "\u201D"), /*#__PURE__*/React.createElement("div", {
    className: "who"
  }, b.who))))));
}

/* ---------------- KIT DE BIENVENIDA ---------------- */
function AgKit() {
  const k = AG.kit;
  return /*#__PURE__*/React.createElement("section", {
    className: "ag-kit",
    id: "kit"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ag-kit-bg reveal"
  }, /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("source", {
    media: "(max-width: 767px)",
    srcSet: "https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_1_jul_2026_03_11_13_a.m..png?v=1782846724"
  }), /*#__PURE__*/React.createElement("img", {
    src: AUREA_ASSET("gift.jpg"),
    alt: "Kit de bienvenida AUREA",
    className: "ag-kit-bgimg"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "ag-kit-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ag-kit-panel-in reveal"
  }, /*#__PURE__*/React.createElement("h2", null, "S\xE9 de las primeras en Chile"), /*#__PURE__*/React.createElement("div", {
    className: "ag-kit-main"
  }, /*#__PURE__*/React.createElement("div", {
    className: "name"
  }, k.mainName, /*#__PURE__*/React.createElement("small", null, k.mainSub))), /*#__PURE__*/React.createElement("p", {
    className: "ag-kit-incl"
  }, "Tu Kit de Bienvenida incluye"), /*#__PURE__*/React.createElement("ul", {
    className: "ag-kit-rows"
  }, k.items.map((it, idx) => /*#__PURE__*/React.createElement("li", {
    key: idx
  }, /*#__PURE__*/React.createElement("div", {
    className: "it"
  }, /*#__PURE__*/React.createElement("b", null, it.b), /*#__PURE__*/React.createElement("p", null, it.p)), /*#__PURE__*/React.createElement("span", {
    className: "val"
  }, /*#__PURE__*/React.createElement(AgIco, {
    type: "tick",
    cls: "kit-tick"
  }), " ", /*#__PURE__*/React.createElement("span", {
    className: "free"
  }, "Incluido"))))), /*#__PURE__*/React.createElement("div", {
    className: "ag-kit-form"
  }, /*#__PURE__*/React.createElement(WaitlistForm, {
    tone: "onGold",
    id: "agKit"
  })), /*#__PURE__*/React.createElement("div", {
    className: "ag-kit-note"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(AgIco, {
    type: "tick",
    cls: "kit-tick"
  }), " Garant\xEDa de devoluci\xF3n de 30 d\xEDas"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(AgIco, {
    type: "tick",
    cls: "kit-tick"
  }), " Cancela cuando quieras"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(AgIco, {
    type: "tick",
    cls: "kit-tick"
  }), " Precio congelado 24 meses")))));
}

/* ---------------- RESEÑAS LARGAS ---------------- */
function AgTestimonials() {
  return /*#__PURE__*/React.createElement("section", {
    className: "section ag-testi"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-head reveal"
  }, /*#__PURE__*/React.createElement("h2", null, "Esto es lo que dicen nuestras clientas.")), /*#__PURE__*/React.createElement("div", {
    className: "ag-testi-grid"
  }, AG.longReviews.map((t, i) => /*#__PURE__*/React.createElement("figure", {
    className: "ag-testi-card reveal",
    key: i,
    style: {
      transitionDelay: i * 80 + 'ms'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "stars"
  }, t.stars), /*#__PURE__*/React.createElement("h4", null, t.h), /*#__PURE__*/React.createElement("p", null, t.p), /*#__PURE__*/React.createElement("figcaption", {
    className: "who"
  }, "\u2014 ", t.who))))));
}

/* ---------------- ESTÁNDARES ---------------- */
function AgQuality() {
  const [open, setOpen] = React.useState(-1);
  return /*#__PURE__*/React.createElement("section", {
    className: "section ag-quality"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap ag-quality-inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ag-quality-main reveal"
  }, /*#__PURE__*/React.createElement("h2", null, "Probado para quienes ", /*#__PURE__*/React.createElement("em", null, "se cuidan de verdad.")), /*#__PURE__*/React.createElement("p", null, "En AUREA no seguimos los est\xE1ndares de calidad del sector: los superamos. Desde la formulaci\xF3n y la selecci\xF3n de ingredientes hasta la producci\xF3n, cada porci\xF3n sigue procesos estrictos para asegurar que ofrece lo que promete."), /*#__PURE__*/React.createElement("div", {
    className: "ag-quality-acc"
  }, AG.quality.map((q, i) => {
    const isOpen = open === i;
    return /*#__PURE__*/React.createElement("div", {
      className: 'ag-qa-item' + (isOpen ? ' open' : ''),
      key: i
    }, /*#__PURE__*/React.createElement("button", {
      className: "ag-qa-q",
      "aria-expanded": isOpen,
      onClick: () => setOpen(isOpen ? -1 : i)
    }, /*#__PURE__*/React.createElement("span", {
      className: "ag-qa-check"
    }, /*#__PURE__*/React.createElement(AgIco, {
      type: "tick",
      cls: ""
    })), /*#__PURE__*/React.createElement("span", {
      className: "ag-qa-label"
    }, q.t), /*#__PURE__*/React.createElement("span", {
      className: "pm"
    })), /*#__PURE__*/React.createElement("div", {
      className: "ag-qa-a",
      style: {
        maxHeight: isOpen ? '180px' : '0'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "ag-qa-a-inner"
    }, q.d)));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "ag-quality-media reveal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ph"
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_29_jun_2026_12_32_45_a.m..png?v=1782814197",
    alt: "Calidad AUREA",
    className: "ag-quality-img"
  })))));
}

/* ---------------- HISTORIA ---------------- */
function AgStory() {
  return /*#__PURE__*/React.createElement("section", {
    className: "ag-story"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap ag-story-inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ph reveal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ag-story-photo"
  }, /*#__PURE__*/React.createElement("img", {
    src: AUREA_ASSET("eduardo.jpg"),
    alt: "Eduardo G\xF3mez, cofundador de AUREA"
  }), /*#__PURE__*/React.createElement("span", {
    className: "cap"
  }, "Eduardo")), /*#__PURE__*/React.createElement("div", {
    className: "ag-story-photo"
  }, /*#__PURE__*/React.createElement("img", {
    src: AUREA_ASSET("oswaldo.jpg"),
    alt: "Oswaldo G\xF3mez, cofundador de AUREA"
  }), /*#__PURE__*/React.createElement("span", {
    className: "cap"
  }, "Oswaldo"))), /*#__PURE__*/React.createElement("div", {
    className: "reveal"
  }, /*#__PURE__*/React.createElement("h2", null, "Dos hermanos, ", /*#__PURE__*/React.createElement("em", null, "un mismo prop\xF3sito.")), /*#__PURE__*/React.createElement("p", null, "AUREA naci\xF3 de nuestra propia b\xFAsqueda. Durante a\xF1os convivimos con la incomodidad de la hinchaz\xF3n y la pesadez, y encontramos que la mayor\xEDa de los suplementos promet\xEDan mucho y entregaban poco."), /*#__PURE__*/React.createElement("p", null, "Decidimos crear lo que nosotros busc\xE1bamos: una f\xF3rmula honesta, con rigor cient\xEDfico, pensada para acompa\xF1ar de verdad \u2014no para vender humo."), /*#__PURE__*/React.createElement("p", {
    className: "sign"
  }, "\u2014 Eduardo & Oswaldo G\xF3mez"), /*#__PURE__*/React.createElement("a", {
    className: "btn btn-ghost-light",
    href: "about.html"
  }, "Conoce nuestra historia"))));
}

/* ---------------- FAQ ---------------- */
function AgFaq() {
  const [open, setOpen] = React.useState(0);
  return /*#__PURE__*/React.createElement("section", {
    className: "section ag-faq",
    id: "preguntas"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap ag-faq-inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ag-faq-head reveal"
  }, /*#__PURE__*/React.createElement("h2", null, "\xBFTienes preguntas?", /*#__PURE__*/React.createElement("br", null), "Tenemos las respuestas.")), /*#__PURE__*/React.createElement("div", {
    className: "ag-faq-list reveal"
  }, AG.faqs.map((f, i) => {
    const isOpen = open === i;
    return /*#__PURE__*/React.createElement("div", {
      className: 'ag-faq-item' + (isOpen ? ' open' : ''),
      key: i
    }, /*#__PURE__*/React.createElement("button", {
      className: "ag-faq-q",
      "aria-expanded": isOpen,
      onClick: () => setOpen(isOpen ? -1 : i)
    }, f.q, /*#__PURE__*/React.createElement("span", {
      className: "pm"
    })), /*#__PURE__*/React.createElement("div", {
      className: "ag-faq-a",
      style: {
        maxHeight: isOpen ? '340px' : '0'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "ag-faq-a-inner"
    }, f.a)));
  }))));
}

/* ---------------- CIERRE ---------------- */
function AgClosing() {
  return /*#__PURE__*/React.createElement("section", {
    className: "section ag-closing",
    id: "lista"
  }, /*#__PURE__*/React.createElement("video", {
    className: "ag-closing-bg",
    src: "https://cdn.shopify.com/videos/c/o/v/5c44c511ba9944e88ae4c34ea73e2a75.mp4",
    poster: AUREA_ASSET("cta-gold.jpg"),
    autoPlay: true, muted: true, loop: true, playsInline: true, preload: "auto"
  }), /*#__PURE__*/React.createElement("div", {
    className: "ag-closing-overlay"
  }), /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "reveal"
  }, "Tu cuerpo lleva tiempo pidi\xE9ndote ", /*#__PURE__*/React.createElement("span", {
    className: "hl hl-dark"
  }, "calma.")), /*#__PURE__*/React.createElement("p", {
    className: "reveal"
  }, "Menos hinchaz\xF3n, m\xE1s energ\xEDa, una mente m\xE1s clara. S\xE9 de las primeras en empezar \u2014con tu precio congelado por 24 meses."), /*#__PURE__*/React.createElement("div", {
    className: "hero-cta reveal"
  }, /*#__PURE__*/React.createElement(WaitlistForm, {
    tone: "onGold",
    id: "agClose"
  })), /*#__PURE__*/React.createElement("div", {
    className: "perks reveal"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(AgIco, {
    type: "tick",
    cls: "perk-tick"
  }), " Acceso anticipado 24 h"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(AgIco, {
    type: "tick",
    cls: "perk-tick"
  }), " Precio congelado 24 meses"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(AgIco, {
    type: "tick",
    cls: "perk-tick"
  }), " Sin compromiso"))));
}

/* ---------------- FOOTER ---------------- */
function AgFooter() {
  return /*#__PURE__*/React.createElement("footer", {
    className: "ag-foot"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "top"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Logo, {
    variant: "gold",
    height: 30
  }), /*#__PURE__*/React.createElement("p", {
    className: "tagline"
  }, "El equilibrio empieza adentro.")), /*#__PURE__*/React.createElement("div", {
    className: "cols"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "about.html"
  }, "Nosotros")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "#lista"
  }, "Lista Dorada")))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "/pages/politicas-de-privacidad"
  }, "Privacidad")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "/pages/preguntas-frecuentes"
  }, "Preguntas frecuentes")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "/pages/terminos-y-condiciones"
  }, "T\xE9rminos y condiciones")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "/pages/politica-suscripcion"
  }, "Pol\xEDtica de suscripci\xF3n")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "/pages/cambios-y-devoluciones"
  }, "Cambios y Devoluciones")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "/pages/envios-y-despacho"
  }, "Env\xEDos y Despacho")))), /*#__PURE__*/React.createElement("div", {
    className: "ag-foot-contact"
  }, /*#__PURE__*/React.createElement("h4", null, "Contacto"), /*#__PURE__*/React.createElement("a", {
    className: "ag-foot-ig",
    href: "https://instagram.com/itsaurea.cl",
    target: "_blank",
    rel: "noopener"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24", width: "16", height: "16", fill: "none", stroke: "currentColor", strokeWidth: "1.6", "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("rect", { x: "3", y: "3", width: "18", height: "18", rx: "5" }), /*#__PURE__*/React.createElement("circle", { cx: "12", cy: "12", r: "4" }), /*#__PURE__*/React.createElement("circle", { cx: "17.2", cy: "6.8", r: "1", fill: "currentColor", stroke: "none" })), " itsaurea.cl"), /*#__PURE__*/React.createElement("a", {
    className: "ag-foot-mail",
    href: "mailto:hola@itsaurea.cl"
  }, "hola@itsaurea.cl"), /*#__PURE__*/React.createElement("p", {
    className: "ag-foot-hours"
  }, "Lun a vie 9:00 a 19:00", /*#__PURE__*/React.createElement("br", null), "S\xE1b 9:00 a 16:00")))), /*#__PURE__*/React.createElement("div", {
    className: "legalbar"
  }, /*#__PURE__*/React.createElement("p", {
    className: "disc"
  }, "\xA9 2026, Aurea \xB7 Todos los derechos reservados"))));
}

/* ---------------- APP ---------------- */
function AgApp() {
  useReveal();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AgHeader, null), /*#__PURE__*/React.createElement("main", null, /*#__PURE__*/React.createElement(AgHero, null), /*#__PURE__*/React.createElement(AgRoutine, null), /*#__PURE__*/React.createElement(AgReplace, null), /*#__PURE__*/React.createElement(AgHow, null), /*#__PURE__*/React.createElement(AgSeals, null), /*#__PURE__*/React.createElement(AgKit, null), /*#__PURE__*/React.createElement(AgIngredients, null), /*#__PURE__*/React.createElement(AgQuality, null), /*#__PURE__*/React.createElement(AgFaq, null), /*#__PURE__*/React.createElement(AgClosing, null)), /*#__PURE__*/React.createElement(AgFooter, null));
}
ReactDOM.createRoot(document.getElementById('root')).render(/*#__PURE__*/React.createElement(AgApp, null));